<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    fixed
  >
    <v-list-item>

      <v-list-item-content>
        <v-list-item-title class="title text-center">
          <v-img
            :src="logo()"
            max-height="100px"
            max-width="100%"
            contain
          />
        </v-list-item-title>
        <v-list-item-subtitle
          style="font-size: .65rem!important"
          class=" mt-3 text--disabled"
        >
          Powered by Hiveway
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider/>
    <v-list
      class="pt-0"
      dense
    >
      <v-divider/>

      <v-list-item
        exact
        :to="{ name: 'admin-home'}"
      >
        <v-list-item-action>
          <v-icon>home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('menu.home')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--      <v-list-item exact :to=" {name: 'public-landing'}" :disabled="!hasStripeAccount">-->
      <!--        <v-list-item-action>-->
      <!--          <v-icon>public</v-icon>-->
      <!--        </v-list-item-action>-->
      <!--        <v-list-item-content>-->
      <!--          <v-list-item-title>Online Store <v-icon right small>open_in_new</v-icon></v-list-item-title>-->
      <!--        </v-list-item-content>-->
      <!--      </v-list-item>-->

      <v-divider/>
      <v-list-item :disabled="true">
        <v-list-item-content>
          <v-list-item-title>{{$t('menu.store_front')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="{ name: 'customers'} "
        :disabled="!hasStripeAccount"
      >
        <v-list-item-action>
          <v-icon>group</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('menu.customer')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'invoices'} "
        :disabled="!hasStripeAccount"
      >
        <v-list-item-action>
          <v-icon>receipt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('menu.invoice_list')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'services' }"
        :disabled="!hasStripeAccount"
      >
        <v-list-item-action>
          <v-icon>headset_mic</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> {{ $t('menu.services') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'products' }"
      >
        <v-list-item-action>
          <v-icon>shopping_cart</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.products.plural') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        :to="{ name: 'bookings'} "
        :disabled="!hasStripeAccount"
      >
        <v-list-item-action>
          <v-icon>event</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('menu.bookings')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>



      <v-divider/>

<!--      <v-list-item :disabled="true">-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>{{$t('menu.headings.tools')}}</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->

<!--      <v-list-item :to="{ name: 'tasks' }">-->
<!--        <v-list-item-action>-->
<!--          <v-icon>assignment_turned_in</v-icon>-->
<!--        </v-list-item-action>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>{{$t('menu.tasks')}}</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->

<!--      <v-list-item :to="{ name: 'events' }">-->
<!--        <v-list-item-action>-->
<!--          <v-icon>flash_on</v-icon>-->
<!--        </v-list-item-action>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>Events</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->

<!--      <v-list-item :to="{ name: 'crons' }">-->
<!--        <v-list-item-action>-->
<!--          <v-icon>schedule</v-icon>-->
<!--        </v-list-item-action>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>Scheduled Jobs</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->

      <v-divider/>


      <div v-show="isSessionRoleAdminOrOwner">
        <v-list-item :disabled="true">
          <v-list-item-content>
            <v-list-item-title>{{$t('menu.headings.management')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'schedule'} "
          :disabled="!hasStripeAccount"
        >
          <v-list-item-action>
            <v-icon>date_range</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('menu.schedule')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'users'}">
          <v-list-item-action>
            <v-icon>face</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'groups' }">
          <v-list-item-action>
            <v-icon>group_work</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Groups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'divisions' }">
          <v-list-item-action>
            <v-icon>store</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{$t('common.divisions.plural')}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'coupons' }"
          :disabled="!hasStripeAccount"
        >
          <v-list-item-action>
            <v-icon>local_offer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('common.coupons.plural') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'tax-rates' }"
          :disabled="!hasStripeAccount"
        >
          <v-list-item-action>
            <v-icon>gavel</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.tax_rates') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


      </div>

      <v-divider/>

      <template v-if="isSessionRoleOwner">
        <v-list-item :disabled="true">
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.headings.account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="isSessionRoleOwner"
          exact
          :to="{ name: 'account' }"
        >
          <v-list-item-action>
            <v-icon>account_balance</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>



<!--        <v-list-item-->

<!--          exact-->
<!--          :to="{ name: 'account-billing' }"-->
<!--        >-->
<!--          <v-list-item-action>-->
<!--            <v-icon>attach_money</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>{{ $t('menu.billing') }}</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->

      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'getDisplayName',
      'isLoggedIn',
      'isSessionRoleAdminOrOwner',
      'isSessionRoleOwner',
      'getAuthRole',
      'hasStripeAccount',
      'hasAccessToRoute'
    ]),
    drawer: {
      get() {
        return this.$store.state.drawers.menu.isOpen
          && this.isLoggedIn
      },
      set(val) {
        this.$store.commit('setMenuIsOpen', val)
      }
    }
  },
  methods: {
    ...mapActions([ 'logout' ]),
    companyName() {
      return process.env.VUE_APP_COMPANY_NAME
    },
    logo() {
      let logoImg;

      try {
        logoImg = require(`@/assets/themes/${process.env.VUE_APP_THEME}/logo.svg`)
      }catch (e) {

      }

      if (!logoImg) {
        try {
          logoImg = require(`@/assets/themes/${process.env.VUE_APP_THEME}/logo.png`)
        }catch (e) {

        }
      }

      return logoImg
    }
  }
}
</script>
